import { useOrderFormStore } from 'stores/orderForm/orderForm';
import { HeaderSectionDivider } from 'components/OrderFormPageLayout/components/Header/components/HeaderSection';

import { OrderFormCheckoutButton } from './components/OrderFormCheckoutButton/OrderFormCheckoutButton';
import { OrderFormMinAmountProgressBar } from './components/OrderFormMinAmountProgressBar/OrderFormMinAmountProgressBar';
import { OrderFormNumberOfItems } from './components/OrderFormNumberOfItems/OrderFormNumberOfItems';
import { OrderFormSubtotal } from './components/OrderFormSubtotal/OrderFormSubtotal';

export const OrderFormHeaderContent = () => {
  const { subtotal, currency, productsHavePrice, numberOfItemsWithQuantity } = useOrderFormStore();

  return (
    <>
      {productsHavePrice ? (
        <OrderFormSubtotal subtotal={subtotal} currency={currency} />
      ) : (
        <OrderFormNumberOfItems numberOfItems={numberOfItemsWithQuantity} />
      )}
      <HeaderSectionDivider />
      <OrderFormMinAmountProgressBar />
      <OrderFormCheckoutButton />
    </>
  );
};
